export default function htmlDecode(input) {
    // var doc = new DOMParser().parseFromString(input, "text/html");
    // return doc.documentElement.textContent;
    var txt = document.createElement("textarea");
    txt.innerHTML = input;
    return txt.value;
}
